import React from "react";

const CustomButton = ({ label, type, onClick, loading, outLined, disable }) => {
  return (
    <div>
      <button
        disabled={loading || disable}
        type={type || "button"}
        onClick={onClick}
        style={{
          width: "100%",
          minWidth: "164px",
          padding: "8px 24px",
          borderRadius: "4px",
          fontSize: "1rem",
          fontWeight: "600",
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          alignItems: "center",
          backgroundColor: outLined ? "transparent" : "#DA2128",
          color: outLined ? "#DA2128" : "#ffffff",
          border: outLined ? "2px solid #DA2128" : "none",
          cursor: "pointer",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.target.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
        }}
        onMouseLeave={(e) => {
          e.target.style.boxShadow = "none";
        }}
      >
        {loading ? <span className="btn_loader"></span> : label}
      </button>
    </div>
  );
};

export default CustomButton;
